export default {
  TITLE: "Produits vendus (Caisses)",
  SUBTITLE: "Ventes provenant des caisses ISTHERA",

  // Filtres
  ESTABLISHMENTS: "Établissements",
  SERVICE_CENTER: "Centre de service",
  CAFETERIA: "Cafétéria",
  CAISSES: "Caisses",
  DEPARTMENT_CODE: "Département (code)",
  SEARCH: "Rechercher (article ou description)",
  GROUP_BY: "Regrouper par",
  AVAILABLE_DATA: "Données disponibles",

  // Axes / dimensions
  DIMENSION_ESTABLISHMENT: "Établissement",
  DIMENSION_SERVICE_CENTER: "Centre de service",
  DIMENSION_CAFETERIA: "Cafétéria",
  DIMENSION_CAISSE: "Caisse",
  DIMENSION_PRODUCT: "Produit",
  DIMENSION_DEPARTMENT: "Département",
  DIMENSION_DAY: "Jour",
  DIMENSION_WEEK: "Semaine",
  DIMENSION_MONTH: "Mois",
  DIMENSION_CASHIER: "Caissier",

  // Colonnes
  ESTABLISHMENT: "Établissement",
  CAISSE: "Caisse",
  ARTICLE: "Article",
  DESCRIPTION: "Description",
  DEPARTMENT: "Département",
  PERIOD: "Période",
  CASHIER: "Caissier",
  QUANTITY: "Quantité",
  COST: "Coût",
  NET_SALES: "Ventes nettes",
  DISCOUNT: "Escompte",

  // Statistiques
  TOTAL_GROUPS: "Lignes",
  TOTAL_QUANTITY: "Quantité totale",
  TOTAL_NET_SALES: "Ventes nettes totales",
  TOTAL_DISCOUNT: "Escompte total",
  TOTAL_COST: "Coût total",

  // Divers
  TOTAL: "Total",
  NO_DATA: "Aucune donnée pour ces critères",
  COST_UNAVAILABLE: "Le coût n'est pas saisi dans ISTHERA (affiché à 0).",
};
